import React, { useState, useEffect } from 'react';
import { db } from '../middleware/firebase';
import {
  getCountFromServer,
  collection,
  orderBy,
  limit,
  query,
  where,
} from 'firebase/firestore';

const useProductCount = (filters) => {
  const [count, setCount] = useState(0);

  const fetchCount = async () => {
    try {
      let thisQuery = query(collection(db, 'products'));

      const {
        brands = [],
        grpsbi = [],
        urlTypes = [],
        size = '',
        additionalAttributes = '',
        //priceRanges = [],
        category = false,
        promotions = false,
        altoValor = false,
        ids = [],
      } = filters;

      let has_data = false;

      if (urlTypes.length) {
        urlTypes.forEach((elem, index) => {
          if (elem) {
            thisQuery = query(
              thisQuery,
              where(`grpsbiObj.${index}`, '==', elem)
            );
          }
        });
      }

      if (size) {
        thisQuery = query(thisQuery, where('grpsbiObj.3', '==', size));
      }

      if (promotions) {
        has_data = true;
        thisQuery = query(
          thisQuery,
          where('has_promotion', '==', true),
          orderBy('grpsbiStr_lvl2')
        );
      }

      if (altoValor) {
        has_data = true;
        thisQuery = query(
          thisQuery,
          where('altoValor', '==', true),
          orderBy('grpsbiStr_lvl2')
        );
      }

      if (category) {
        has_data = true;
        thisQuery = query(
          thisQuery,
          where('category', '==', category),
          orderBy('grpsbiStr_lvl2')
        );
      }

      if (additionalAttributes) {
        thisQuery = query(
          thisQuery,
          where('grpsbiObj.4', '==', additionalAttributes)
        );
      }

      if (grpsbi.length && !(ids && ids.length)) {
        has_data = true;
        thisQuery = query(
          thisQuery,
          where('grpsbi', 'array-contains-any', grpsbi)
        );
      } else if (grpsbi.length) {
        thisQuery = query(
          thisQuery,
          where('grpsbi', 'array-contains', grpsbi[0])
        );
      }

      if (ids && ids.length) {
        has_data = true;
        thisQuery = query(thisQuery, where('id', 'in', ids));
      }

      if (brands.length) {
        has_data = true;
        thisQuery = query(thisQuery, where('aliasd', '==', brands[0]));
      }

      if (!has_data) {
        setCount(null);
        return;
      }

      thisQuery = query(thisQuery, limit(400));
      const countSnapshot = await getCountFromServer(thisQuery);
      console.log('count', countSnapshot.data().count);

      setCount(countSnapshot.data().count);
    } catch (err) {
      console.error('Failed to fetch product count:', err);
      setCount(null);
    }
  };

  useEffect(() => {
    fetchCount();
  }, [JSON.stringify(filters)]);

  return [count];
};

export default useProductCount;
